import {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Section from './UI/Section';
import {Context} from '../context';
import LoadingSpinner from './UI/LoadingSpinner';
import ErrorNote from './UI/ErrorNote';

function VerifyEmail() {
  const {localeText, verifyEmail} = useContext(Context);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const verificationScope = params.get('scope');

    if (!token || !verificationScope) {
      setStatus('invalid');
      return;
    }

    verifyEmail(token, verificationScope)
      .then(ret => {
        if (ret?.data?.verifyEmail?.success && !ret?.errors) {
          setStatus('success');
          return;
        }

        setStatus('error');
      })
      .catch(() => setStatus('error'));
  }, [verifyEmail]);

  if (status === 'loading') {
    return (
      <Section
        sectionId='verify-email'
        heading={localeText('rw_header_verify_email', 'Verify Email')}
        className='h-full'
      >
        <div className='w-full h-full flex justify-center items-center'>
          <LoadingSpinner />
        </div>
      </Section>
    );
  }

  if (status === 'success') {
    return (
      <Section
        sectionId='verify-email'
        heading={localeText('rw_header_verify_email', 'Verify Email')}
        className='h-full'
      >
        <div className='w-full h-full flex flex-col justify-center items-center gap-6'>
          <p className='text-center text-2xl text-green-600'>
            {localeText(
              'rw_verify_email_success',
              'Your email has been verified. You can now sign in.'
            )}
          </p>
          <Link
            to='/login'
            className='text-red underline hover:text-dark'
          >
            {localeText('rw_title_sign_in', 'Sign In')}
          </Link>
        </div>
      </Section>
    );
  }

  return (
    <Section
      sectionId='verify-email'
      heading={localeText('rw_header_verify_email', 'Verify Email')}
      className='h-full'
    >
      <div className='w-full h-full flex flex-col justify-center items-center gap-6'>
        <ErrorNote>
          {status === 'invalid'
            ? localeText(
                'rw_verify_email_invalid_link',
                'This verification link is invalid. Please check your email and try again.'
              )
            : localeText(
                'rw_verify_email_error',
                'Unable to verify your email. The link may have expired. Please register again or contact customer support.'
              )}
        </ErrorNote>
        <Link to='/login' className='text-red underline hover:text-dark'>
          {localeText('rw_title_sign_in', 'Sign In')}
        </Link>
      </div>
    </Section>
  );
}

export default VerifyEmail;
